<glxy-page *ngIf="!hidePageWrapper; else woForms">
  <glxy-page-toolbar>
    <glxy-page-title>{{ 'FULFILLMENT.FULFILLMENT_FORMS' | translate }}</glxy-page-title>
    <glxy-page-nav>
      <glxy-page-nav-button
        [previousPageTitle]="'SALES_ORDERS.ORDERS' | translate"
        [previousPageUrl]="previousPageUrl"
        [useHistory]="true"
        [historyBackButtonTitle]="'COMMON.ACTION_LABELS.BACK' | translate"
      ></glxy-page-nav-button>
    </glxy-page-nav>
    <glxy-page-actions>
      <ng-container [ngTemplateOutlet]="shareButton" />
    </glxy-page-actions>
  </glxy-page-toolbar>
  <glxy-page-wrapper [maxWidth]="1160">
    <ng-container [ngTemplateOutlet]="woForms"></ng-container>
  </glxy-page-wrapper>
</glxy-page>

<ng-template #woForms>
  <ng-container *ngIf="workOrders$ | async as workOrders">
    <div class="container">
      <div class="left-side">
        <div *ngFor="let wo of workOrders; let i = index">
          <ng-template #extraHeaderContent>
            <div class="extra-content">
              <work-order-status-badge
                [value]="wo.status"
                class="status-badge"
                [persona]="persona"
                [attr.id]="wo.appId"
                [attr.fragment]="wo.fulfillmentOrderId"
              ></work-order-status-badge>
            </div>
          </ng-template>
          <div class="work-order-div">
            <work-order-form
              [salesOrderId]="wo.salesOrderId"
              [appId]="wo.appId"
              [accountGroupId]="wo.businessId"
              [marketId]="marketId"
              [resellerPartnerId]="wo.resellerPartnerId"
              [fulfillmentOrderId]="wo.fulfillmentOrderId"
              [status]="wo.status"
              [persona]="persona"
              [extraHeaderContent]="extraHeaderContent"
              (fulfillmentOrderStatusChanged)="statusChanged($event, wo)"
              [showOfficeUseQuestions]="showOfficeUseQuestions"
              [users]="allUsers"
              (doneLoading)="handleDoneLoading(i)"
              [extraActionButtons]="hidePageWrapper ? shareButton : null"
            ></work-order-form>
          </div>
        </div>
        <div *ngIf="(woFormDoneLoading$ | async) === false" class="stencil-shimmer loading-shimmer"></div>
      </div>

      <div *ngIf="woFormDoneLoading$ | async" class="right-side">
        <div class="widgets">
          <work-order-context [accountGroupId]="businessId"></work-order-context>
          <work-order-checklist *ngIf="workOrders.length > 1" [workOrders]="workOrders"></work-order-checklist>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #shareButton>
  <button
    mat-stroked-button
    *ngIf="persona !== WorkOrderPersona.SMB && (users?.length > 0 || allowUserManagement)"
    (click)="openSendEmailDialog()"
    data-action="work-order-form-share-button"
  >
    <mat-icon>person_add</mat-icon>
    {{ 'FULFILLMENT.SHARE' | translate }}
  </button>
  <div
    *ngIf="persona !== WorkOrderPersona.SMB && users?.length === 0 && !allowUserManagement"
    [glxyPopover]="popover"
    (mouseenter)="popover.open()"
    (mouseout)="popover.close()"
    data-action="work-order-form-share-button-disabled"
  >
    <button mat-stroked-button disabled>
      <mat-icon>person_add</mat-icon>
      {{ 'FULFILLMENT.SHARE' | translate }}
    </button>
  </div>
  <glxy-popover #popover [isOpen]="false" [positions]="popoverPosition">
    <glxy-popover-title>{{ 'SHARE.NO_USERS_TOOLTIP' | translate }}</glxy-popover-title>
  </glxy-popover>
</ng-template>
